module.exports = __webpack_public_path__ + "static/img/education.8a144773.svg";